import CustomerDetailsViewModel from './customer-details-view-model';

export class CustomerDetailsPanelContext {
    public constructor(
        public viewModel: CustomerDetailsViewModel
    ) { }
}
